import { defineComponent as _defineComponent } from 'vue'
import {
  MissionLifecycleFragmentFragment,
  UserAdvanced,
  ConsultantMissionLifecycle,
  ClientMissionLifecycleFragmentFragment,
  Comment,
} from "@/gql"
import { computed, ref, watch } from "vue"
import Icon from "@/components/widgets/icons/Icon.vue"
import UserAvatar from "@/components/profile/UserAvatar.vue"
import ChatDialog from "@/modules/Missions/components/Details/Chat/ChatDialog.vue"
import { useTimeAgo } from "@/hooks/useTimeAgo"
import PrimaryButton from "@/components/widgets/button/PrimaryButton.vue"
import useRouter from "@/router/useRouter"


export default /*#__PURE__*/_defineComponent({
  __name: 'ChatSummary',
  props: {
    mission: null
  },
  setup(__props: any) {

const props = __props as {
  mission:
    | MissionLifecycleFragmentFragment
    | ConsultantMissionLifecycle
    | ClientMissionLifecycleFragmentFragment
}



const { router, routes } = useRouter()

const collaborators = computed<UserAdvanced[]>(() => {
  return (props.mission?.collaborators as UserAdvanced[]) ?? []
})

const lastComment = ref<Comment | null>(null)

const currentMessage = computed(() => {
  return lastComment.value || props.mission.defaultConversation?.lastComment
})

const handleMessageSent = (message: Comment) => {
  lastComment.value = message
}

const namesOfCollaborators = collaborators.value?.map((collaborator) => {
  return `${collaborator.firstName} ${collaborator.lastName}`
})

const timeAgo = (date: string) => {
  return useTimeAgo(date)
}

const showChatDialog = ref(false)

const onClose = () => {
  showChatDialog.value = false
  router.push(`/missions/${router.currentRoute.params.id}`)
}

const onOpenMessageDialog = () => {
  showChatDialog.value = true
  router.push({
    name: routes.MissionDetailConversation,
    params: {
      id: router.currentRoute.params.id,
    },
  })
}

watch(
  () => router.currentRoute,
  () => {
    if (router.currentRoute.name === routes.MissionDetailConversation) {
      showChatDialog.value = true
    }
  },
  { immediate: true }
)

return { __sfc: true,props, router, routes, collaborators, lastComment, currentMessage, handleMessageSent, namesOfCollaborators, timeAgo, showChatDialog, onClose, onOpenMessageDialog, Icon, UserAvatar, ChatDialog, PrimaryButton }
}

})